"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const runtime = require("./runtime-Bg1jJ4E0.cjs");
exports.c = runtime.decorateClass;
exports.f = runtime.decorateFieldV1;
exports.g = runtime.decorateFieldV2;
exports.i = runtime.initializeDeferredDecorator;
exports.m = runtime.decorateMethodV1;
exports.n = runtime.decorateMethodV2;
exports.p = runtime.decoratePOJO;
//# sourceMappingURL=runtime.cjs.map
